export default function isLoggedOut(value) {
  if (!value) {
    return true;
  }

  return value.id === undefined;
}
